/**
 * @public
 */
export const LeftPanelDivider = () => {
  return (
    <>
      <cds-left-panel-divider></cds-left-panel-divider>
    </>
  );
};
